import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Modal } from "react-bootstrap";
import { ReactComponent as Blackclose } from "../../assets/images/black-close.svg";
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from "react-share";
import { NotificationManager } from "react-notifications";
import UserService from "../../services/user/user.service";
import AppConfig from "../../config/app.config";
import { updateBannerShare } from "../../store/home/home.actions";

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(
    {
      updateBannerShare,
    },
    dispatch
  ),
});

class ShareModal extends React.Component {
  // dataURLtoFile = (dataurl) => {
  //   if (!dataurl) {
  //     return;
  //   }
  //   var arr = dataurl.split(","),
  //     mime = arr[0].match(/:(.*?);/)[1],
  //     bstr = atob(arr[1]),
  //     n = bstr.length,
  //     u8arr = new Uint8Array(n);

  //   while (n--) {
  //     u8arr[n] = bstr.charCodeAt(n);
  //   }

  //   return new File([u8arr], "image.jpg", { type: mime });
  // };

  shareOnMobile = (url, title, fallback) => {
    // const { url, title, images } = params;

    if (navigator.share === undefined) {
      fallback?.(
        "Can't share on this, make sure you are running on Android or iOS devices"
      );
      console.error("error: navigator.share is not available");
      return;
    }
    if (!title) {
      fallback?.("Title is required");
      console.error("error: title is requied");
      return;
    }

    var shareData = { text: title, title };
    if (url) {
      shareData.url = url;
    }
    // if (Array.isArray(images)) {
    //   var files = images.map((image) => dataURLtoFile(image));
    //   if (files) {
    //     shareData.files = files;
    //   }
    // }
    try {
      if (navigator.canShare && navigator.canShare(shareData)) {
        navigator
          .share(shareData)
          .then(() => console.info("Shared successful."))
          .catch((error) => {
            fallback?.(error.message);
            console.error("Sharing failed ..", error);
          });
      }
    } catch (error) {
      fallback?.(error.message);
      console.error("error: ", error);
    }
  };

  saveShareProjectLog = async () => {
    // console.log("SAVING", this.props.employeeId, this.props.projectId);
    if (this.props.employeeId != null && this.props.projectId != null) {
      try {
        // this.setState({ isLoading: 1 });
        const res = await UserService.saveShareDataLog({
          loginEmployeeId: this.props.employeeId,
          subscriptionId: AppConfig.API.SUBSCRIPTION_ID,
          verticalId: AppConfig.API.VERTICAL_ID,
          appId: AppConfig.API.APP_ID,
          projectId: this.props.projectId,
        });
        // console.log("res", res);
        if (res["status"]) {
          this.props.updateBannerShare({ projectId: this.props.projectId });
        }
      } catch (err) {}
      // this.setState({ isLoading: 0 });
    }
  };

  render() {
    return (
      <Modal
        show={this.props.show}
        onHide={this.props.hideModal}
        backdrop="static"
        keyboard={false}
        centered
        id="ShareModal"
      >
        <div className="modal-close">
          <Blackclose className="closeicon" onClick={this.props.hideModal} />
        </div>
        <div className="share-modal">
          <h4>Share</h4>
          <div className="social-media">
            <EmailShareButton url={this.props.url} title={this.props.title}>
              <img
                src={require("../../assets/images/email.png")}
                className="share-img"
                alt="email"
                onClick={() => {
                  this.saveShareProjectLog();
                }}
              />
            </EmailShareButton>
            <FacebookShareButton
              url={this.props.url}
              onClick={() => this.saveShareProjectLog()}
            >
              <img
                src={require("../../assets/images/facebook.png")}
                className="share-img"
                alt="facebook"
              />
            </FacebookShareButton>
            {/* <img
              src={require("../../assets/images/instagram.png")}
              className="share-img"
              alt="instagram"
            /> */}
            <LinkedinShareButton
              url={this.props.url}
              onClick={() => this.saveShareProjectLog()}
            >
              <img
                src={require("../../assets/images/linkedin.png")}
                className="share-img"
                alt="linkedin"
              />
            </LinkedinShareButton>
            {/* <img
              src={require("../../assets/images/tiktok.png")}
              className="share-img"
              alt="tiktok"
            /> */}
            <TwitterShareButton
              url={this.props.url}
              onClick={() => this.saveShareProjectLog()}
            >
              <img
                src={require("../../assets/images/twitter.png")}
                className="share-img"
                alt="twitter"
              />
            </TwitterShareButton>
          </div>
          <h5>Link</h5>
          <div className="sharebar-link">
            <p>{this.props.url}</p>
            <button
              onClick={() => {
                navigator.clipboard?.writeText(this.props.url);
                NotificationManager.success("", "Link Copied", 3000);
              }}
              type="button"
              className="Copy-btn"
            >
              Copy
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ShareModal);
